import InfoBannerBaseMessage from "./InfoBaseBannerMessage";

const PlatinumBotChatBannerMessage = (): JSX.Element => {
    return (
        <InfoBannerBaseMessage>
            <b>Platinum Chat Update:</b> Your experience may look a little
            different - chats now start with Pepper, our automated assistant,
            who can help with orders, account questions, and more. You can still
            chat with the Platinum team at any time, Monday - Friday: 8AM - 8PM
            EST.
        </InfoBannerBaseMessage>
    );
};

export default PlatinumBotChatBannerMessage;
